import { Component } from '@angular/core';
import {
  ActivatedRoute,
  Router,
  RouterModule,
  RouterOutlet,
} from '@angular/router';

import { UserRoleType, UserService } from 'BaseServices/user-service';
import { DateAdapter } from '@angular/material/core';
import {
  NavigationHeaderComponent,
  headerItem,
} from '@standard-angular-utilities/shared-components';
import trainingtrackingRouteConfig from '../training-tracking-base/Routes';
import { SharedFunctionsService } from 'BaseServices/sharedFunctions.service';

enum RoleId {
  Admin = 1,
  Manager = 2,
  User = 3,
  EnrollmentManager = 6,
}

@Component({
  selector: 'training-tracking-base-root',
  templateUrl: './training-tracking-base.component.html',
  styleUrl: './training-tracking-base.component.css',
  imports: [RouterModule, RouterOutlet, NavigationHeaderComponent],
})
export class TrainingTrackingBaseComponent {
  userRoleType = UserRoleType;

  get currentUser() {
    return this.userService.currentUser;
  }

  constructor(
    public userService: UserService,
    private dateAdapter: DateAdapter<Date>,
    private sharedFunctionsService: SharedFunctionsService
  ) {
    this.userService.userStatusChanged$.subscribe((result) => {
      if (result) {
        this.addRoutes();
      }
    });
  }

  addRoutes() {
    if (!this.currentUser) {
      return;
    }

    this.userService.setRouteConfig(trainingtrackingRouteConfig);

    this.userService.routesAndNames.forEach((headerItem) => {
      if (
        headerItem.name === 'Kurser' &&
        this.userService.getSelectedRole === UserRoleType.User
      ) {
        headerItem.name = 'Mine kurser';
      }
    });
  }

  ngOnInit() {
    this.dateAdapter.setLocale('da-DK');
  }
}
